import { PaginatedResponse, PaginationParams } from "@ac-expo/api-types";
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { Notification } from "@ac-expo/api-types";

const getNotifications = async (pagination: PaginationParams) => {
  const { data } = await privateAxios.get<PaginatedResponse<Notification>>(
    "/notifications",
    { params: pagination }
  );
  return data;
};

export const useGetNotificationsInfiniteQuery = () => {
  return useInfiniteQuery({
    queryKey: ["notifications"],
    queryFn: ({ pageParam }) => getNotifications(pageParam),
    initialPageParam: {
      pageIndex: 0,
      pageSize: 20,
    },
    getNextPageParam: (lastPage: PaginatedResponse<Notification>) => {
      if (
        !lastPage.pageSize ||
        (!lastPage.pageIndex && lastPage.pageIndex !== 0)
      )
        return undefined;

      if (lastPage.count < (lastPage.pageIndex + 1) * lastPage.pageSize)
        return undefined;

      return {
        pageIndex: lastPage.pageIndex + 1,
        pageSize: lastPage.pageSize,
      };
    },
  });
};

const readNotification = async (id: string) => {
  const { data } = await privateAxios.post(`notifications/${id}/read`);
  return data;
};

export const useReadNotificationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => readNotification(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["notifications"],
      });
    },
  });
};

const readManyNotifications = async (ids: string[]) => {
  const { data } = await privateAxios.post(`notifications/read`, {
    notificationIds: ids,
  });
  return data;
};

export const useReadManyNotificationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ids: string[]) => readManyNotifications(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["notifications"],
      });
    },
  });
};
